import { render } from "./exwarehouseall.vue?vue&type=template&id=60047ab7"
import script from "./exwarehouseall.vue?vue&type=script&lang=js"
export * from "./exwarehouseall.vue?vue&type=script&lang=js"

import "./exwarehouseall.vue?vue&type=style&index=0&id=60047ab7&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__